import { formatDistanceToNowStrict } from 'date-fns';

const timeFromNow = (date) => {
  return formatDistanceToNowStrict(new Date(date), { addSuffix: true });
};

export default timeFromNow;
